import { FilterOperator, FiltersType, TableId } from "../models/vcloud-api";

export type AzureFilterDefinition = {
  displayName: string;
  id: string;
  table: TableId;
  type: FiltersType;
};

// Filter API service constants
export const FILTERS_API_ENDPOINTS = {
  GROUP_BY: "queries/group-by",
} as const;

export const FILTERS_API_TIMEOUTS = {
  COST_TRACKER_DELAY: 2000,
  ALERT_DISMISS_TIMEOUT: 3500,
} as const;

export const FILTERS_STORAGE_KEYS = {
  PREVIOUS_FILTERS_PREFIX: "previousFilters/",
} as const;

export const FILTER_OPERATORS_DEFAULT: Record<string, FilterOperator[]> = {
  DATE_RANGE: [">=", "<="],
} as const;

export const AZURE_FILTER_DEFINITIONS: AzureFilterDefinition[] = [
  {
    displayName: "Enrollment Account",
    id: "enrollment_account",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Account Owner",
    id: "AccountOwnerId",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Resource Group",
    id: "ResourceGroup",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Charge",
    id: "MeterName",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Location",
    id: "ResourceLocation",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Region",
    id: "MeterRegion",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Sub-Category",
    id: "MeterSubCategory",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Service Category",
    id: "MeterCategory",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Service",
    id: "ConsumedService",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Charge Frequency",
    id: "Frequency",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Plan",
    id: "PlanName",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Billing Account",
    id: "BillingAccountName",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Charge Type",
    id: "ChargeType",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Vendor",
    id: "PublisherName",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Vendor Type",
    id: "PublisherType",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Publisher",
    id: "PublisherType",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Product",
    id: "ProductName",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Service Family",
    id: "ServiceFamily",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Local Market",
    id: "local_market",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Subscription ID",
    id: "subscription_id",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Subscription",
    id: "subscription_name",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Subscription Owner",
    id: "subscription_owner",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Business Unit",
    id: "bu",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Programme",
    id: "programme",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Cost Center",
    id: "CostCenter",
    table: "Table_1",
    type: FiltersType.string,
  },
  {
    displayName: "Environment",
    id: "environment",
    table: "Table_2",
    type: FiltersType.string,
  },
  {
    displayName: "Group",
    id: "group",
    table: "Table_2",
    type: FiltersType.string,
  },
];

// Debug capture service constants
export const CAPTURE_RESPONSE = {
  STORAGE_KEY: "capturedResponsesVcs",
  EXCLUDED_PATH: "/vcloudsmart/assistant",
  MAX_HISTORY: 20,
  MAX_RESULTS: 10,
} as const;
